export const iconFontAwesomeLogisticsAnchorLock = (
	<i className="fa-solid fa-anchor-lock"></i>
);
